import { Box } from '@mui/material';
import React from 'react';
import { CheckboxGroupInput, DateInput, required } from 'react-admin';
import { AttendantGoalBoardDaysOfWeek } from '../../../models/attendantGoal';
import dayjs from 'dayjs';

const FormSchedule: React.FC<{ formData?: any }> = ({ formData }) => {
  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: 3, flexWrap: 'wrap' }}>
        <DateInput
          source="startDate"
          label="Data inicial"
          validate={[required()]}
          fullWidth={false}
          parse={value => value ? dayjs(value).startOf('day').toISOString() : null}
        />
        <DateInput
          source="endDate"
          label="Data final"
          validate={[required()]}
          fullWidth={false}
          parse={value => value ? dayjs(value).startOf('day').toISOString() : null}
        />
      </Box>

      <CheckboxGroupInput
        source="daysOfWeek"
        label="Dias da semana"
        choices={AttendantGoalBoardDaysOfWeek.attendantGoalBoardDaysOfWeekChoices}
        validate={[required()]}
      />
    </>
  );
}

export default FormSchedule;
